<template>
  <v-card elevation="0" :color="$vuetify.theme.dark ? 'transparent' : 'transparent'" class="pl-3 edit-news">
    <v-container class="custom-container responsive-height">
      <v-row>
        <v-col cols="12">
          <v-card-title class="pb-0">
            Update Email Addresses
          </v-card-title>
        </v-col>
        <v-col cols="12">
          <v-card class="deposit-form px-5" :color="$vuetify.theme.dark ? 'transparent' : 'transparent'">
            <v-row v-for="group in fieldGroups" :key="group.title">
              <v-col cols="12">
                <h3>{{ group.title }}</h3>
              </v-col>
              <v-col cols="12" xl="6" lg="6" md="6" v-for="field in group.fields" :key="field">
                <fieldset>
                  <legend>{{ fieldLabels[field] }}</legend>
                  <v-text-field :disabled="$canRoute('email-address') !== 1" v-model="form[field]" single-line solo hide-details
                    class="custom-select"></v-text-field>
                </fieldset>
              </v-col>
            </v-row>
          </v-card>
        </v-col>
        <v-col cols="12" v-if="$canRoute('email-address') === 1">
          <v-btn large tile elevation="0" class="ml-5 text-capitalize btn-account" color="greenMain"
            @click="submitForm">
            Update
          </v-btn>
        </v-col>
      </v-row>
    </v-container>
  </v-card>
</template>

<script>
import { mapState, mapActions } from "vuex";
import { EMAILCONFIG__ACTIONS } from "@/store/action-types";

export default {
  data() {
    return {
      form: {
        contact: "",
        deposit_from: "",
        deposit_to: "",
        withdraw_from: "",
        withdraw_to: "",
        account_opening: "",
        inttxt_from: "",
        inttxt_to: "",
        partner_inttxt_from: "",
        partner_inttxt_to: "",
        partner_withdraw_from: "",
        partner_withdraw_to: "",
        ticket_from: "",
        ticket_to: "",
        support: "",
        open_trading_account: "",
        open_demo_account: "",
        trading_report: "",
        birthday: "",
        back_office: "",
        no_reply: "",
      },

      fieldGroups: [
        {
          title: "Deposit",
          fields: ["deposit_from", "deposit_to"]
        },
        {
          title: "Withdraw",
          fields: ["withdraw_from", "withdraw_to", "partner_withdraw_from", "partner_withdraw_to"]
        },
        {
          title: "Internal Transfer",
          fields: ["inttxt_from", "inttxt_to", "partner_inttxt_from", "partner_inttxt_to"]
        },
        {
          title: "Account",
          fields: ["account_opening", "open_trading_account", "open_demo_account"]
        },
        {
          title: "Ticket",
          fields: ["ticket_from", "ticket_to"]
        },
        {
          title: "Others",
          fields: ["contact", "support", "no_reply", "back_office", "trading_report", "birthday"]
        },

      ],
      fieldLabels: {
        contact: "Contact Email",
        deposit_from: "Deposit Email From",
        deposit_to: "Deposit Email To",
        withdraw_from: "Withdraw Email From",
        withdraw_to: "Withdraw Email To",
        account_opening: "Account Opening Email",
        inttxt_from: "Internal Transfer From",
        inttxt_to: "Internal Transfer To",
        partner_inttxt_from: "Partner Internal Transfer From",
        partner_inttxt_to: "Partner Internal Transfer To",
        partner_withdraw_from: "Partner Withdraw From",
        partner_withdraw_to: "Partner Withdraw To",
        ticket_from: "Ticket Email From",
        ticket_to: "Ticket Email To",
        support: "Support Email",
        open_trading_account: "Open Trading Account Email",
        open_demo_account: "Open Demo Account Email",
        trading_report: "Trading Report Email",
        birthday: "Birthday Email",
        back_office: "Backoffice Email",
        no_reply: "No Reply Email",
      },
    };
  },

  computed: {
    ...mapState("emailconfig", ["email_config"]),
    ...mapState("admins", ["loggedAdmin"]),
  },

  methods: {
    ...mapActions("emailconfig", [
      EMAILCONFIG__ACTIONS.EMAILCONFIG,
      EMAILCONFIG__ACTIONS.UPDATEEMAILCONFIG,
    ]),
    
    async submitForm() {
      try {
        await this[EMAILCONFIG__ACTIONS.UPDATEEMAILCONFIG](this.form);
      } catch (error) {
        console.error("Error submitting form:", error);
      }
    },

    populateForm() {
      if (this.email_config) {
        Object.keys(this.form).forEach(key => {
          this.form[key] = this.email_config[key] || "";
        });
      }
    },
  },

  async created() {
    await this[EMAILCONFIG__ACTIONS.EMAILCONFIG]();
    this.populateForm();
  },
};
</script>